<template lang="pug">
  .component-editor
    ckeditor(:editor="editor", :config="editorConfig", v-model="editorData", @ready="setText", :disabled="disabled")
</template>
<script type="text/babel">

import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {
  name: 'Editor',
  components: {},
  data() {
    return {
      editor: ClassicEditor,
      editorData: '',
      editorConfig: {
        toolbar: ['heading', '|', 'bold', 'italic', 'bulletedList', 'numberedList', 'link'],
        heading: {
          options: [
            {model: 'paragraph', title: 'Paragraph'},
            {model: 'heading1', view: 'h1', title: 'Heading 1'},
            {model: 'heading2', view: 'h2', title: 'Heading 2'},
            {model: 'heading3', view: 'h3', title: 'Heading 3'}
          ]
        }
      },
    }
  },
  watch: {
    editorData: function (val) {
      const emptyParagraph = new RegExp('<p>&nbsp;</p>', 'g');
      if (emptyParagraph.test(val)) {
        val = null
      }
      this.$emit('input', val)
    },
  },
  methods: {
    setText() {
      this.editorData = this.value
    }
  },
  computed: {},
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled:{
      type: Boolean,
    }
  }
}
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// Editor.vue?568e63f8